import { createStore } from 'vuex'

import Loading from 'quasar/src/plugins/Loading.js';import QSpinnerBall from 'quasar/src/components/spinner/QSpinnerBall.js';

// var URL = 'http://36.88.33.75:5062/';
var URL = 'https://servermarina.konaweselatankab.go.id/';
// var URL = 'http://localhost:5033/';
// var URL = 'http://10.91.178.2:5033/';

const store = createStore({
  state: {
    url : {
      URL_APP : URL,
      URL_BERANDA : URL + "api/v1/beranda/",
      URL_PENGGUNA : URL + "api/v1/registrasi/",
      URL_LEVEL : URL + "api/v1/level/",
      URL_KATEGORI : URL + "api/v1/kategori/",
      URL_WILAYAH : URL + "api/v1/wilayah/",
      URL_PELAKU : URL + "api/v1/pelaku/",
      URL_PRODUK  : URL + "api/v1/produk/",
      URL_UMUM  : URL + "api/v1/umum/",
      URL_BANNER  : URL + "api/v1/banner/"
    }
  },
  getters: {
  },
  mutations: {
    getStorage(state){
      var get_profile = JSON.parse(localStorage.profile);
      state.unit_kerja = get_profile.profile.unit_kerja; 
    },
    showLoading(){
      Loading.show({
        spinner : QSpinnerBall,
        spinnerColor: 'purple-12',
        spinnerSize: 140,
        backgroundColor: 'grey-2',
        // message: 'Loading... Tunggu beberapa saat, system sedang menyesuaikan akun anda..!',
        // messageColor: 'white'
      })
    },
    hideLoading(){
      Loading.hide()
    },

  },
  actions: {
  },
  modules: {
  }
})

export default store;